"use strict";

import Vue from 'vue'

const EventBus = new Vue()

export default EventBus;



// WEBPACK FOOTER //
// ./resources/wob/vue/events/event-bus.js